import { IFundPriceTableRow, INewsItemType } from '../types';
import { format } from 'date-fns';

export const filterFundPrices = (
  searchTerm: string,
  fundPricesList: IFundPriceTableRow[],
  lang: { EN: boolean; FI: boolean }
) =>
  fundPricesList.filter((priceItem) => {
    return (lang.EN ? priceItem.companyNameEn : priceItem.companyNameFi)
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
  });

export const filterNewsItems = (
  searchTerm: string,
  newsList: INewsItemType[],
  language: { EN: boolean; FI: boolean }
) =>
  newsList.filter(({ title, content }) => {
    const lowerCaseSearch = searchTerm.toLowerCase();
    const titleText = language.EN ? title.en || '' : title.fi || '';
    const titleMatches = titleText.toLowerCase().includes(lowerCaseSearch);
    return (
      titleMatches ||
      content[0].value?.toLowerCase().includes(lowerCaseSearch) ||
      content[1].value?.toLowerCase().includes(lowerCaseSearch) ||
      content[2].value?.toLowerCase().includes(lowerCaseSearch) ||
      content[3].value?.toLowerCase().includes(lowerCaseSearch)
    );
  });

export const sort = (
  sortType: keyof IFundPriceTableRow,
  fundUnits: IFundPriceTableRow[]
) =>
  fundUnits.sort((a, b) => {
    if (
      sortType === 'closePrice' ||
      sortType === 'lowestValueYTD' ||
      sortType === 'highestValueYTD'
    ) {
      return Number(a[sortType]) > Number(b[sortType]) ? 1 : -1;
    } else if (
      sortType === 'companyNameEn' ||
      sortType === 'companyNameFi' ||
      sortType === 'currency'
    ) {
      return a[sortType].trim().toLowerCase() > b[sortType].trim().toLowerCase()
        ? 1
        : -1;
    } else
      return getDate(a[sortType] as string) > getDate(b[sortType] as string)
        ? 1
        : -1;
  });

export const formatDate = (date: string) => {
  const year = Number(date.substring(0, 4));
  const month = Number(date.substring(4, 6));
  const day = Number(date.substring(6, 8));
  const newDate = format(new Date(year, month - 1, day), 'dd.MM.yyyy');
  return newDate;
};

export const getDate = (date: string) => {
  const year = Number(date?.substring(0, 4));
  const month = Number(date?.substring(4, 6));
  const day = Number(date?.substring(6, 8));
  return new Date(year, month - 1, day);
};

export const sortByVisibleDate = (data: INewsItemType[]) => {
  return data.sort((item1, item2) => {
    const date1 = new Date(item1.visible_date).getTime();
    const date2 = new Date(item2.visible_date).getTime();
    return date1 > date2 ? -1 : date1 < date2 ? 1 : 0;
  });
};
